import {Component, Input} from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-free-offering-button',
  templateUrl: './free-offering-button.component.html',
  styleUrls: ['./free-offering-button.component.scss'],
  standalone: true,
  imports: [
    RouterLink
  ]
})
export class FreeOfferingButtonComponent {
  @Input()
  buttonText: string;
  @Input()
  link: string;
  @Input()
  internalLink = false;

  constructor() { }

}
